import {
  Box,
  Checkbox,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";

const CargaSemanalGrid = ({ dias, menus, matrix, feriados, onToggleCelda, onToggleFeriado }) => {
  if (!menus.length) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
          py: 5,
          color: "text.secondary",
        }}
      >
        <EventBusyIcon sx={{ fontSize: 32, opacity: 0.5 }} />
        <Typography>Este proveedor no tiene menús activos.</Typography>
        <Typography variant="body2">Cargá menús para poder armar la semana.</Typography>
      </Box>
    );
  }

  return (
    <TableContainer component={Paper} elevation={0} sx={{ border: "1px solid rgba(0,0,0,0.08)", borderRadius: 3 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 700, bgcolor: "rgba(212,230,241,0.6)" }}>Menú</TableCell>
            {dias.map((dia) => {
              const esFeriado = !!feriados[dia.fecha];
              return (
                <TableCell
                  key={dia.fecha}
                  align="center"
                  sx={{
                    minWidth: 120,
                    bgcolor: esFeriado ? "rgba(211,47,47,0.1)" : "rgba(212,230,241,0.6)",
                    borderBottom: esFeriado ? "2px solid #D32F2F" : undefined,
                    transition: "background-color .15s ease",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: "0.8rem",
                      textTransform: "capitalize",
                      color: esFeriado ? "#B71C1C" : "inherit",
                      mb: 0.5,
                    }}
                  >
                    {dia.labelCorto} {dia.diaMes}
                  </Typography>
                  <Chip
                    size="small"
                    onClick={() => onToggleFeriado(dia.fecha)}
                    icon={
                      esFeriado ? (
                        <EventBusyIcon sx={{ fontSize: 14 }} />
                      ) : (
                        <EventAvailableIcon sx={{ fontSize: 14 }} />
                      )
                    }
                    label={esFeriado ? "Feriado" : "Marcar feriado"}
                    color={esFeriado ? "error" : "default"}
                    variant={esFeriado ? "filled" : "outlined"}
                    sx={{
                      cursor: "pointer",
                      fontWeight: 700,
                      height: 22,
                      fontSize: "0.65rem",
                      "& .MuiChip-icon": { ml: 0.5 },
                    }}
                  />
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {menus.map((m) => (
            <TableRow key={m.id} hover>
              <TableCell sx={{ fontWeight: 500, fontSize: "0.85rem" }}>{m.nombre}</TableCell>
              {dias.map((dia) => {
                const key = `${dia.fecha}|${m.id}`;
                const esFeriado = !!feriados[dia.fecha];
                return (
                  <TableCell
                    key={key}
                    align="center"
                    sx={{
                      bgcolor: esFeriado ? "rgba(211,47,47,0.05)" : undefined,
                      borderLeft: esFeriado ? "1px solid rgba(211,47,47,0.15)" : undefined,
                      borderRight: esFeriado ? "1px solid rgba(211,47,47,0.15)" : undefined,
                    }}
                  >
                    {esFeriado ? (
                      <Typography
                        variant="caption"
                        sx={{ color: "#B71C1C", fontWeight: 600, fontStyle: "italic" }}
                      >
                        Feriado
                      </Typography>
                    ) : (
                      <Checkbox
                        checked={!!matrix[key]}
                        onChange={() => onToggleCelda(dia.fecha, m.id)}
                      />
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CargaSemanalGrid;
